
import React, { useState, useEffect } from "react";
import {
  FaTrophy, FaGamepad, FaChartLine, FaMedal, FaBars, FaHome, FaUsers,
  FaCog, FaDiceD20, FaScroll, FaNewspaper, FaLink, FaShieldAlt, FaFlag
} from "react-icons/fa";
import { GiCrossedSwords } from "react-icons/gi";
import axios from "axios";
import logo from "../img/COBRADOR_LEAGUE_LOGO_02_FINAL.png";
import vortem from "../img/vortem2.png";
import { useArmyboard } from "../hooks/useArmyboard";
import { useLeaderboard } from "../hooks/useLeaderboard";
import { getArmyIcon } from "../util/getArmyIcon";
import { useLocation } from "react-router-dom";

const apiUrl = "https://elcobradorleague.com/api";

const HomeWH40K = () => {
  //const idleague = 2;
  const location = useLocation();
  const [idleague, setIdleague] = useState(null);

  useEffect(() => {
      const params = new URLSearchParams(location.search);
      const id = params.get("idleague");
      setIdleague(id ? parseInt(id) : 1);
    }, [location]);

  const { factions } = useArmyboard(idleague);
  const { divisions } = useLeaderboard(idleague);
  const [lastMatches, setLastMatches] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Phase 1");

  useEffect(() => {
    fetchLastMatches();    
  }, []);  

  const fetchLastMatches = async () => {
    try {
      const response = await axios.get(`${apiUrl}/api.php?endpoint=matches`);
      setLastMatches(response.data);
    } catch (error) {
      console.error("Error fetching matches:", error);
    }
  };

  const menuItems = [
    { name: "WH40k League", icon: FaHome, link: "/wh40k?idleague="+idleague  },
    { name: "Leaderboard", icon: FaTrophy, link: "/leaderboardv2?idleague="+idleague },
    { name: "Matches", icon: FaGamepad },
    { name: "Players", icon: FaUsers },
    { name: "Rules", icon: FaScroll },
    { name: "Settings", icon: FaCog },
  ];

  const phaseTabs = ["Phase 1", "Phase 2: Decepticons", "Phase 3: Competitors", "Play-off"];

  const topArmy = factions.flatMap(f => f.armies).sort((a, b) => b.points - a.points)[0];
  const TopArmyIcon = topArmy ? getArmyIcon(topArmy.army_name) : null;

  return (
    <div className="flex flex-col min-h-screen bg-gray-900 text-white">
      <header className="bg-gray-800 p-4 shadow-lg">
        <div className="container mx-auto flex justify-between items-center">
          <div className="flex items-center space-x-4">
            <img src={logo} alt="El Cobrador League Logo" className="w-10 h-10 rounded-full" />
            <h1 className="text-2xl font-bold">El Cobrador League - Warhammer 40k</h1>
          </div>
          <button onClick={() => setMenuOpen(!menuOpen)} className="lg:hidden text-white">
            <FaBars size={24} />
          </button>
          <nav className={`lg:flex space-x-4 ${menuOpen ? "block" : "hidden"}`}>
            {menuItems.map((item, index) => (
              <a key={index} href={item.link} className="flex items-center space-x-1 text-gray-300 hover:text-white transition duration-200">
                <item.icon className="inline-block mr-1" />
                <span>{item.name}</span>
              </a>
            ))}
          </nav>
        </div>
      </header>     

      <div className="flex-1 p-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
        <div className="space-y-8">
          <div className="rounded-lg bg-gray-800 p-6 shadow-lg">
            <h2 className="mb-4 text-2xl font-semibold text-center">League Statistics</h2>
            <div className="flex space-x-2 justify-center mb-4">
              {phaseTabs.map(tab => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`px-4 py-2 rounded ${activeTab === tab ? "bg-blue-600" : "bg-gray-700"}`}
                >
                  {tab}
                </button>
              ))}
            </div>
            {activeTab === "Phase 1" && (
              <div className="space-y-6">
                {divisions.map((division, index) => (
                  <div key={index} className="rounded-lg bg-gray-700 p-4">
                    <h3 className="mb-2 text-xl font-semibold text-center text-blue-400">
                      {division.division}
                    </h3>
                    <table className="w-full table-auto">
                      <thead>
                        <tr className="bg-gray-600">
                          <th className="px-2 py-1 text-left">Pos.</th>
                          <th className="px-2 py-1 text-left">Player</th>
                          <th className="px-2 py-1 text-center">GP</th>
                          <th className="px-2 py-1 text-center">TP</th>
                        </tr>
                      </thead>
                      <tbody>
                        {division.players.map((player, i) => (
                          <tr key={i} className="hover:bg-gray-600">
                            <td className="px-2 py-1">{i+1}</td>
                            <td className="px-2 py-1">{player.nick}</td>
                            <td className="px-2 py-1 text-center">{player.played}</td>
                            <td className="px-2 py-1 text-center">{player.points}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ))}
              </div>
            )}
            {activeTab !== "Phase 1" && (
              <p className="text-center text-gray-400">No data available for this phase.</p>
            )}
          </div>
        </div>

        <div className="rounded-lg bg-gray-800 p-6 shadow-lg">
          <h2 className="mb-4 text-2xl font-semibold text-center">Player Info</h2>
          <div className="space-y-2 max-h-[600px] overflow-y-auto">
            {lastMatches.slice(0, 6).map((match) => {
              const ArmyIconP1 = getArmyIcon(match.army_p1);             
              const ArmyIconP2 = getArmyIcon(match.army_p2);            
              return (
                 console.log(match),
                <div key={match.id} className="rounded-lg bg-gray-700 p-2 space-y-2">                 
                    <div className="text-gray-400 text-center">{match.division_name} [{match.date}]</div>                                           
                <div className="grid grid-cols-[1fr_1fr_0.5fr_0.5fr_0.5fr_1fr_1fr] items-center text-center gap-x-1">
                  <div>{ArmyIconP1 && <img src={ArmyIconP1} alt="Army 1 Icon" className="w-10 h-10 mx-auto" />}</div>
                  <div className="text-right text-white">{match.nick1}<br/><p className="text-gray-500 text-sm">{match.army_p1}</p></div>
                  <div className={(match.score_p1 > match.score_p2 ? "text-green-300" : match.score_p1 < match.score_p2 ? "text-red-300" : "") + " text-xl font-bold text-right"}>{match.score_p1}</div>
                  <div className="text-white col-span-1 flex justify-center">vs</div>
                  <div className={(match.score_p2 > match.score_p1 ? "text-green-300" : match.score_p2 < match.score_p1 ? "text-red-300" : "") + " text-xl font-bold text-left"}>{match.score_p2}</div>
                  <div className="text-left text-white">{match.nick2}<br/><p className="text-gray-500 text-sm">{match.army_p2}</p></div>
                  <div>{ArmyIconP2 && <img src={ArmyIconP2} alt="Army 2 Icon" className="w-10 h-10 mx-auto" />}</div>
                </div>
              </div>
              );
            })}
          </div>
        </div>

        <div className="rounded-lg bg-gray-800 p-6 shadow-lg self-start">
          <h2 className="mb-4 text-2xl font-semibold text-center">Faction On Fire</h2>
          {TopArmyIcon && <img src={TopArmyIcon} alt="Top Army Icon" className="w-40 h-40 mx-auto mb-4" />}
          <table className="w-full table-auto">
            <thead>
              <tr className="bg-gray-700">
                <th className="px-2 py-1 text-left">Pos.</th>
                <th className="px-2 py-1 text-left">Army</th>
                <th className="px-2 py-1 text-center">GP</th>
                <th className="px-2 py-1 text-center">TP</th>
              </tr>
            </thead>
            <tbody>
              {factions.flatMap(f => f.armies).map((army, index) => (
                <tr key={index} className="hover:bg-gray-600">
                  <td className="px-2 py-1">{index+1}</td>
                  <td className="px-2 py-1">{army.army_name}</td>
                  <td className="px-2 py-1 text-center">{army.won + army.lost + army.drawn}</td>
                  <td className="px-2 py-1 text-center">{army.points}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default HomeWH40K;